import {
  ApiBlueprint,
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import GitHubIcon from '@mui/icons-material/GitHub';
import { default as React } from 'react';

import { HesselsGithubClient, hesselsGithubApiRef } from './api';
import { rootRouteRef } from './routes';

const hesselsGithubPage = PageBlueprint.make({
  params: {
    routeRef: rootRouteRef,
    path: '/hessels-github',
    title: 'GitHub',
    icon: React.createElement(GitHubIcon),
    loader: () =>
      import('./components/HesselsGithubContent').then(m =>
        React.createElement(m.HesselsGithubContent),
      ),
  },
});

const hesselsGithubApi = ApiBlueprint.make({
  name: 'hessels-github-api',
  params: defineParams =>
    defineParams({
      api: hesselsGithubApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new HesselsGithubClient(discoveryApi, fetchApi),
    }),
});

export const hesselsGithubPlugin = createFrontendPlugin({
  pluginId: 'hessels-github',
  routes: {
    root: rootRouteRef,
  },
  extensions: [hesselsGithubPage, hesselsGithubApi],
});
